<template>
    <div class="ui tiny modal popup maxtura-popup" ref="modal">
        <a class="content" href="/nagradna-igra" @click="showRemind(7)">
            <a href="#" class="close-button" style="text-decoration: none;" @click.stop.prevent="showRemind(14)">x</a>
            <a class="interaction">
                <input type="checkbox" name="maxtura-popup" value="true" ref="cookie-check" id="maxtura-popup">
            </a>
        </a>
    </div>
</template>

<script>
    import popup from './Popup.vue'

    export default {
        mixins: [popup],
        props: ['data'],
        data() {
            return {
                checkboxIsClicked: false
            }
        },
        methods: {
            checkboxClicked() {
                this.checkboxIsClicked = !this.checkboxIsClicked;
            },
            dontShowAnymore() {
                let cookieName = this.$refs['cookie-check'].name;
                this.$cookies.set(cookieName, true, 60 * 60 * 24 * 30);
                this.$root.$emit('close-popup', this);
                $(this.$refs['modal']).modal('hide');
            },
            showCustom(days = 1) {
                let cookieNameOnce = this.$refs['cookie-check'].name + '_once';
                let cookieName = this.$refs['cookie-check'].name;
                if (!this.checkboxIsClicked) {
                    this.$cookies.set(cookieNameOnce, true, 60 * 60 * 24 * days);
                }
                else {
                    this.$cookies.set(cookieName, true, 60 * 60 * 24 * 30);
                }
                this.$root.$emit('close-popup', this);
                $(this.$refs['modal']).modal('hide');
            },
            showRemind(days = 1) {
                console.log('showRemind', days);
                // if (!this.checkboxIsClicked) {
                //     this.dontShowAnymore();
                // }
                // else {
                    let cookieNameOnce = this.$refs['cookie-check'].name + '_once';
                    this.$cookies.set(cookieNameOnce, true, 60 * 60 * 24 * days);
                    this.$root.$emit('close-popup', this);
                    $(this.$refs['modal']).modal('hide');
                // }
            }
        },
    }
</script>
